import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { chuongTrinhDaoTaoRangBuocApi } from "../../../api/ctdt/chuongTrinhDaoTaoRangBuocApi";
import { eChuongTrinhDaoTaoRangBuocActionIds, IChuongTrinhDaoTaoRangBuocActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoRangBuocActions";
import { IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest } from "../../../model/request/ctdt/IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest";
import { IChuongTrinhDaoTaoRangBuocActionTypeBase } from "../../action-types/ctdt/IChuongTrinhDaoTaoRangBuocActions";
import { NotifyHelper } from "../../../helpers/toast";

export function* chuongTrinhDaoTaoRangBuocSaga(): any {
    yield takeLatest(eChuongTrinhDaoTaoRangBuocActionIds.LOAD_START, loadWorker);
    yield takeEvery(eChuongTrinhDaoTaoRangBuocActionIds.SAVE_MULTIPLE_START, saveMultipleWorker);
}

function* loadWorker(action: IChuongTrinhDaoTaoRangBuocActionTypes): any {
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoRangBuocApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoRangBuoc.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoRangBuoc.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveMultipleWorker(action: IChuongTrinhDaoTaoRangBuocActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoRangBuocActionTypeBase<IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest>;
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoRangBuocApi.InsertMultiple, payload.data);
    if (res.is_success) {
        NotifyHelper.Success(res.data?.message ?? "Lưu ràng buộc thành công");
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoRangBuoc.SAVE_MULTIPLE_SUCCESS(res.data));
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.SAVE_RANGBUOC_SUCCESS({
            id_dt: payload.id_dt,
            data: undefined
        }));
    } else {
        NotifyHelper.Error(res.message ?? "Có lỗi");
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoRangBuoc.SAVE_MULTIPLE_ERROR(res.message ?? "Có lỗi"));
    }
}